var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayBuilding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_4169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99805 14.6565V2.66448C3.99805 2.31109 4.13843 1.97218 4.38831 1.7223C4.6382 1.47241 4.97711 1.33203 5.3305 1.33203H10.6603C11.0137 1.33203 11.3526 1.47241 11.6025 1.7223C11.8524 1.97218 11.9927 2.31109 11.9927 2.66448V14.6565H3.99805Z",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99693 7.99414H2.66448C2.31109 7.99414 1.97218 8.13452 1.7223 8.38441C1.47241 8.63429 1.33203 8.9732 1.33203 9.32659V13.3239C1.33203 13.6773 1.47241 14.0162 1.7223 14.2661C1.97218 14.516 2.31109 14.6564 2.66448 14.6564H3.99693",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9922 5.99609H13.3246C13.678 5.99609 14.0169 6.13648 14.2668 6.38636C14.5167 6.63624 14.6571 6.97516 14.6571 7.32854V13.3246C14.6571 13.678 14.5167 14.0169 14.2668 14.2668C14.0169 14.5166 13.678 14.657 13.3246 14.657H11.9922",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66211 3.99805H9.32701",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66211 6.66211H9.32701",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66211 9.32812H9.32701",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66211 11.9922H9.32701",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_4169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayBuilding);
export default __webpack_public_path__ + "static/media/gray_building.9a4b4b7b1bc028a86b62cef2ab1c3988.svg";
export { ForwardRef as ReactComponent };